<template>
  <div>
    <v-card>
      <v-row class="pa-3" v-if="componenteEvento.agregar_submodulo">
        <v-spacer></v-spacer>
        <ButtonComp @click="addItem" textButton="Agregar documento" iconBut="fas fa-plus" normalButton />
      </v-row>

      <ComundataTablecompVue whitSearch noResultsText="Sin datos para mostrar" :headers="DocuemntosFotosRequeridosHeaders"
        :items="documentos" :search="search">

        <template v-slot:action_editar="{ item }">
          <ButtonComp v-if="componenteEvento.editar_submodulo" @click="editItem(item)" editButton
            tooltipText="Editar admisión" />
        </template>

        <template v-slot:action_ver="{ item }">
          <ButtonComp v-if="componenteEvento.visualizar_submodulo" @click="editItem(item, true)" verButton
            tooltipText="Ver admisión" />

        </template>

        <template v-slot:action_borrar="{ item }">
          <ButtonComp v-if="componenteEvento.borrar_submodulo" @click="deleteConfirm(item)" deleteButton
            tooltipText="Eliminar admisión" />

        </template>
      </ComundataTablecompVue>
    </v-card>
    <!--  FIN lIST DE REGISTROS --->

    <!-- modal para crear/editar documentos -->
    <v-form ref="formDatos" v-model="validdocs" lazy-validation>
      <ComunDialogComp v-model="dialog" maxWidth="700" @close-modal="dialog = false">
        <template v-slot:title>
          {{ formTitle }} y foto
        </template>
        <template v-slot:body>
          <v-row>
            <!-- {{admisiones}} -->
            <v-col md="4">
              <AutocompleteComp v-model="editedItem.id_admision" textLabel="Año académico" :items="parametros.admisiones"
                item-value="id" item-text="ano_academico" :rules="validationRules.validateCampo"
                :readonly="bloquearCampo" />
            </v-col>

            <v-col md="8">
              <textfieldComp textLabel="Título" v-model="editedItem.titulo" :rules="validationRules.validateCampo"
                :readonly="bloquearCampo" />
            </v-col>
            <v-row>
              <v-col class="d-flex justify-end">
                <v-checkbox v-model="editedItem.fotos_carrusel" label="Agregar al portal de fotos"
                  :readonly="bloquearCampo"></v-checkbox>
              </v-col>
            </v-row>
            <v-col cols="12" sm="12" md="12">

              <v-file-input v-if="editedItem.fotos_carrusel" :clearable="habilitado" v-model="editedItem.archivo"
                prepend-icon="mdi-camera" :disabled="bloquearCampo" show-size @change="onArchivoChange" :rules="habilitado
                  ? [rul.fotos, rul.required]
                  : [rul.pdfs, rul.required]
                  " :label="textCondicion"></v-file-input>

              <v-file-input v-else :clearable="habilitado" label="Agrega documentos o videos" v-model="editedItem.archivo"
                :disabled="bloquearCampo" @change="onArchivoChange"></v-file-input>
            </v-col>
          </v-row>
        </template>
        <template v-slot:actions>
          <v-spacer></v-spacer>
          <ButtonComp v-if="evento == 'editar'" @click="editDocumento(editedItem.id)" textButton="Guardar cambios"
            iconBut="fas fa-save" normalButton />
          <ButtonComp v-if="evento == 'agregar'" @click="addDocumento" textButton="Guardar" iconBut="fas fa-save"
            normalButton />
        </template>
      </ComunDialogComp>

    </v-form>
    <!--------->

    <!-- //////////////Modal para confirmar eliminacion /////////////////////    -->
    <ComunDialogComp v-model="dialog_confirm" Confirmdialog @close-modal="dialog_confirm = false"
      @cancel-item="funcionConfirm('no')" titleWindow="Crear registro" @confirm-item="funcionConfirm('si')">
      <template v-slot:body>
        {{ desc_confirm }} <br />
        {{ name_confirm }}
      </template>
    </ComunDialogComp>

    <ComunDialogComp v-model="dialog_delete" Deletedialog @close-modal="dialog_delete = false"
      @cancel-item="funcionConfirm('no')" titleWindow="Eliminar registro" @delete-item="funcionConfirm('si')">
      <template v-slot:body>
        {{ desc_confirm }} <br />
        {{ name_confirm }}
      </template>
    </ComunDialogComp>
    
    <!-- fin de modal de borrar registro -->
  </div>
</template>

<script>
import axios from "../../../../helpers/axios";
import { mapMutations, mapGetters, mapActions } from "vuex";
import ComundataTablecompVue from "@/components/ComponentsEst/ComundataTablecomp.vue"
import ButtonComp from '../../../../components/ComponentsEst/TableButtonComp.vue';
import ComunDialogComp from '../../../../components/ComponentsEst/ComunDialogComp.vue';
import textfieldComp from '../../../../components/ComponentsEst/textfieldComp.vue';
import AutocompleteComp from '../../../../components/ComponentsEst/AutocompleteComp.vue';
import { DocuemntosFotosRequeridosHeaders } from '../../../../helpers/headersTable';
import { validationRules } from '../../../../helpers/validatorHelpers';


export default {
  name: "Configuracion",
  props: {
    parametros: {
      type: Object,
      default: Object,
    },
  },
  components: { ComundataTablecompVue, ButtonComp, ComunDialogComp, textfieldComp, AutocompleteComp },
  data: () => ({
    validdocs: true,
    textCondicion: "Adjuntar documento, video ó foto (pdf, docx, png, jpg)",
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    paramComponente: { id_submodulo: 141, id_modulo: 5 }, //sud_modulo y modulo

    datoLogin: sessionStorage, // variables de sesion del usuario
    ////////////////////////////////////////////////////////
    bloquearCampo: false,
    search: "",
    DocuemntosFotosRequeridosHeaders,


    fotos_carrusel: false,

    //validaciones de formulario
    rul: {
      required: (value) => !!value || "Campo requerido",
      max5Mb: (v) =>
        !v ||
        v.size < 5000000 ||
        "El tamaño del documento debe ser inferior a 5 MB!",
      fotos: (value) =>
        !value ||
        ["image/jpeg", "image/png", "image/jpg"].includes(value.type) ||
        "Solo puedes subir fotos en formato JPEG, PNG o JPG",
      pdfs: (value) => !value || value || "Puedes todo",
    },

    // modal agregar editar documento
    dialog: false,
    evento: "",
    editedItem: {},
    documentos: [],

    habilitado: false,

    // modal confirmacion
    name_confirm: "",
    id_delete: null,
    dialog_confirm: false,
    dialog_delete : false,
    desc_confirm: "",
    eventoConfirm: "",
    //////////////////////////////////
  }),

  computed: {
    ...mapGetters("login", ["componenteEvento"]),

    formTitle() {
      return this.evento === "agregar"
        ? "Agregar documento"
        : this.evento === "ver"
          ? "Ver documento"
          : "Editar documento";
    },

    validationRules() {
      return validationRules;
    }
  },

  mounted() {
    this.getDocumentos();
  },

  created() {
    this.actualizarParamentro();
  },

  watch: {
    editedItem(object) {
      if (object.fotos_carrusel) {
        this.habilitado = true;
        this.editedItem.archivo = null;
        this.textCondicion = "Solo cargar imágenes para el carrusel";
      } else {
        this.habilitado = false;
        this.textCondicion =
          "Adjuntar documento, video ó foto (pdf, docx, png, jpg)";
      }
    },
  },

  methods: {
    logFormData() {
      for (let pair of this.formData.entries()) {
        console.log(pair[0] + ": " + pair[1]);
      }
    },

    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //----- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    ////////////////////////////////////////////////////////

    ////////  METODO QUE LIMPIA EL FORMULARIO Y VARIABLES /////////
    async limpiarForm() {
      this.editedItem = {
        id: 0,
        id_colegio: this.datoLogin.id_colegio,
        id_admision: "",
        titulo: "",
        enlace: "",
        archivo: null,
        id_usuario: this.datoLogin.id,
      };
      // this.$refs.formDatos.resetValidation();
    },

    async downloadArchivo() {
      axios({
        url: `${this.editedItem.uri}?download=true`,
        method: "GET",
        responseType: "blob", // important
      })
        .then((response) => {
          if (response.status == 200) {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute("download", this.editedItem.nombre_original);
            document.body.appendChild(fileLink);
            fileLink.click();
            this.setEnviarMens({
              tipo: "S",
              mensaje: "Se descargó el archivo",
              tiempo: null,
            });
          } else {
            this.setEnviarMens({
              tipo: "E",
              mensaje: "Ocurrio error al descargar, Intenta mas tarde.",
              tiempo: null,
            });
          }
        })
        .catch(() => {
          this.setEnviarMens({
            tipo: "E",
            mensaje: "Ocurrio error al descargar, Intenta mas tarde.",
            tiempo: null,
          });
        });
    },

    onArchivoChange(e) {

      if (e !== undefined) {
        this.editedItem.archivo = e;
      } else {
        this.editedItem.archivo = null;
      }
    },

    //////// METODO PARA HABILITAR MODAL PARA AGREGAR UN ITEM NUEVO //
    addItem() {
      this.getDocumentos();
      this.evento = "agregar";
      this.limpiarForm();
      this.bloquearCampo = false;
      this.dialog = true;
    },

    async getDocumentos() {
      try {
        let response = await axios.get(
          `/admision/documentos/${this.datoLogin.id_colegio}`
        );
        this.documentos = response.data;
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },

    //----------Crear Nueva Documento ---------------
    async addDocumento() {
      if (this.$refs.formDatos.validate() == true) {
        let valorf = this.editedItem.fotos_carrusel ? true : false;

        if (this.$refs.formDatos.validate()) {
          if (this.editedItem.archivo == null && this.editedItem.enlace == "") {
            this.setEnviarMens({
              tipo: "W",
              mensaje: `Debe de ingresar el archivo o el enlace del documento`,
              tiempo: null,
            });
          } else {
            try {
              let formData = new FormData();
              formData.append("id_admision", this.editedItem.id_admision);
              formData.append("id_usuario", this.datoLogin.id);
              formData.append("id_colegio", this.datoLogin.id_colegio);
              formData.append("titulo", this.editedItem.titulo);
              formData.append("enlace", this.editedItem.enlace);
              formData.append("fotos_carrusel", valorf);

              if (this.editedItem.archivo != null)
                formData.append("subirArchivo", this.editedItem.archivo);
              let response = await axios.post(
                "/admision/documentos/",
                formData
              );

              if (response.data.messageT == "S") {
                this.getDocumentos();

                this.agregarOtroDocumento();
              }

              this.setEnviarMens({
                tipo: response.data.messageT,
                mensaje: response.data.message,
                tiempo: null,
              });
            } catch (e) {
              this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
            }
          }
        } else {
          this.setEnviarMens({
            tipo: "W",
            mensaje: `Debe de ingresar todos los campos requeridos`,
            tiempo: null,
          });
        }
      }
    },

    //---------------- Editar Documento ----------------
    async editDocumento(id) {
      if (this.$refs.formDatos.validate()) {
        let formData = new FormData();
        formData.append("id_admision", this.editedItem.id_admision);
        formData.append("id_usuario", this.datoLogin.id);
        formData.append("id_colegio", this.datoLogin.id_colegio);
        formData.append("titulo", this.editedItem.titulo);
        formData.append("enlace", this.editedItem.enlace);
        if (this.editedItem.archivo != null)
          formData.append("archivo", this.editedItem.archivo);

        try {
          let response = await axios.put(
            `/admision/documentos/${id}`,
            formData
          );
          if (response.data.messageT == "S") {
            this.getDocumentos();
            this.dialog = false;
            this.limpiarForm();
          }
          this.setEnviarMens({
            tipo: response.data.messageT,
            mensaje: response.data.message,
            tiempo: null,
          });
        } catch (e) {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        }
      } else {
        this.setEnviarMens({
          tipo: "W",
          mensaje: `Debe de ingresar todos los campos requeridos`,
          tiempo: null,
        });
      }
    },

    agregarOtroDocumento() {
      this.eventoConfirm = "agregarOtroDocumento";
      this.dialog_confirm = true;

      this.desc_confirm = "¿Desea agregar otro documento?";
    },

    //------------FUNCION CONFIRMAR -------------
    async funcionConfirm(resp) {
      if (resp == "si" && this.eventoConfirm == "borrar") {
        this.deleteDocumento();
      } else if (resp == "no" && this.eventoConfirm == "borrar") {
        this.dialog_confirm = false;
        this.dialog_delete = false;
      } else if (resp == "si" && this.eventoConfirm == "agregarOtroDocumento") {
        this.dialog_confirm = false;
        this.dialog_delete = false;
        this.limpiarForm();
        this.$refs.formDatos.resetValidation();
      } else {
        this.dialog_confirm = false;
        this.dialog = false;
        this.dialog_delete = false;
      }
    },

    //---------obtener datos pàra editar
    editItem(item, ver = false) {
      this.limpiarForm();
      this.evento = ver == true ? "ver" : "editar";
      if (ver == true) {
        this.bloquearCampo = true;
      } else {
        this.bloquearCampo = false;
      }
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    // *****  confirmar el eliminar **********
    deleteConfirm(item) {
      this.eventoConfirm = "borrar";
      this.id_delete = item.id;
      this.name_confirm = `Documento: ${item.titulo}`;
      this.desc_confirm = "¿Está seguro de eliminar este registro?";
      this.dialog_delete = true;
    },

    //------------ borrar documento -------------
    async deleteDocumento() {
      try {
        let response = await axios.delete(
          `/admision/documentos/${this.id_delete}`
        );
        this.dialog_delete = false;

        if (response.data.messageT == "S") {
          this.getDocumentos();
        }

        this.setEnviarMens({
          tipo: response.data.messageT,
          mensaje: response.data.message,
          tiempo: null,
        });
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },
  },
};
</script>

